import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ReactHighcharts from '../../CommonComponents/Highcharts';
import LoadingChart from '../../CommonComponents/LoadingChart';
import { getGoalsChartList } from '../../HealthCareChart/HealthCareChartActions';
import * as healthCareSelector from '../../HealthCareChart/HealthCareChartSelector';

const HealthCareGoalChartView = props => {
  const { clientId, fpId, goalId, initialChartData, title } = props;
  const dispatch = useDispatch();

  const chartData = useSelector(state => healthCareSelector.goalChartPopulated(state, props));
  const hasLoaded = useSelector(state => healthCareSelector.hasLoaded(state, props));

  useEffect(() => {
    if (!initialChartData) {
      dispatch(getGoalsChartList(fpId, clientId, false, goalId));
    }
  }, [fpId]);

  return (
    <div className="carousel-healthcare-chart-container">
      <h4>{title}</h4>
      <section
        className="
        healthCare-chart-component
        chart"
      >
        <div
          className="
          healthcare-chart-container
          NewFinancialPlan_ProgressChart
          NewFinancialPlan_HealthCareProgressChart"
        >
          {!hasLoaded && <LoadingChart />}

          {hasLoaded && (
            <div className="chart_container">
              <ReactHighcharts autoResize options={chartData} container="HealthCareContainer" />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

HealthCareGoalChartView.propTypes = {
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  initialChartData: PropTypes.shape({}).isRequired,
  goalId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default HealthCareGoalChartView;
